import React, { useEffect, useState, useContext, useCallback } from 'react';
import { Nav, NavItem, NavLink, Card, CardBody, CardTitle } from 'reactstrap';
import { timeAgo } from "../../Services/helper"

import { AppContext } from "../../store/AppContext";
import DetailsModal from "../../components/DetailsModal";
import CategoryList from "../../components/CategoryList";
import { getMyPublishedVideos, getMyUnPublishedVideos } from "../../Services";

import "./myVideos.scss";

const asVideoList = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.items)) return payload.items;
  return [];
};

const MyVideos = () => {
    const [data, setData] = useState([]);
    const { categories, userDetails } = useContext(AppContext);
    const [activeTab, setActiveTab] = useState(1);
    const [selectedId, setSelectedId] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [loading, setLoading] = useState(false);

    const fetchData = useCallback(async (tab, category) => {
        if (!category) {
            setData([]);
            return;
        }
        setLoading(true);
        try {
            const response = tab === 1
                ? await getMyPublishedVideos(category)
                : await getMyUnPublishedVideos(category);
            setData(asVideoList(response));
        } catch (err) {
            console.error('MyVideos fetch failed', err);
            setData([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (!selectedCategory && Array.isArray(categories) && categories.length > 0) {
            setSelectedCategory(categories[0]);
        }
    }, [categories, selectedCategory]);

    useEffect(() => {
        if (selectedCategory) {
            fetchData(activeTab, selectedCategory);
        }
    }, [selectedCategory, activeTab, fetchData]);

    const onCardClick = (item) => {
        setSelectedId(item);
        if (item?.category) {
            setSelectedCategory(item.category);
        }
    };

    const onTabSwitch = (value) => {
        setActiveTab(value);
        setData([]);
    };

    const videos = asVideoList(data);

    return (
      <div className="container my-videos-page">
        <CategoryList active={selectedCategory} onCategorySelection={setSelectedCategory} />
        {selectedId !== null && (
          <DetailsModal
            id={selectedId.key}
            title={selectedId.videoName}
            viewCount={selectedId.viewCount}
            content={selectedId.description}
            uploadedDate={selectedId.dateUploaded}
            attachment={selectedId.attachmentKey}
            onClose={() => setSelectedId(null)}
            isApproval={false}
            category={selectedCategory}
            isDeletable={userDetails?.role === "USER" || userDetails?.role === "ADMIN"}
            hideRelaventVideos={true}
            selectVideo={onCardClick}
          />
        )}
        <Nav tabs>
            <NavItem>
                <NavLink
                    className={activeTab === 1 ? "active" : ""}
                    onClick={() => onTabSwitch(1)}
                >
                    Approved Videos
                </NavLink>
            </NavItem>
            <NavItem>
                <NavLink
                    className={activeTab === 2 ? "active" : ""}
                    onClick={() => onTabSwitch(2)}
                >
                    Unapproved Videos
                </NavLink>
            </NavItem>
        </Nav>
        <div className="my-videos-category-label">
            {selectedCategory ? `Category: ${String(selectedCategory).replace(/[*^]/g, '').trim()}` : ''}
        </div>
        <div className="videos-container">
            {videos.map((item) => (
              <Card
                key={item.key || item.videoKey || item.videoName}
                title={item.videoName}
                className="my-video-card"
                onClick={() => onCardClick(item)}
              >
                <div>
                    <img alt={item.videoName || 'video'} src={item.imageKey} />
                </div>
                <CardBody title={item.videoName}>
                    <CardTitle tag="h5" title={item.videoName}>{item.videoName}</CardTitle>
                    <div className='cardStyle'>
                        <span className="time-ago-badge" title="views">{`${item.viewCount ?? 0} views`}</span>
                        <span className="time-ago-badge" title="published">
                          {timeAgo(item.publishedDate || item.dateUploaded || Date.now())}
                        </span>
                    </div>
                </CardBody>
              </Card>
            ))}
            {!loading && videos.length === 0 ? (
              <div className="no-records">No record found!</div>
            ) : null}
            {loading && videos.length === 0 ? (
              <div className="no-records">Loading…</div>
            ) : null}
        </div>
      </div>
    );
};

export default MyVideos;
